import BlogCard from './BlogCard';

export default BlogCard;



// WEBPACK FOOTER //
// ./src/components/shared/BlogCard/index.js